import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyA89w65QpguCGQwJS6i8ig5tSH2OxBlcAg",
    authDomain: "mtb-trail-status.firebaseapp.com",
    databaseURL: "https://mtb-trail-status.firebaseio.com",
    projectId: "mtb-trail-status",
    storageBucket: "mtb-trail-status.appspot.com",
    messagingSenderId: "885313271794",
    appId: "1:885313271794:web:3a1243789f165ad07edd6b",
    measurementId: "G-JN43Q0YHKM"
};

// const config = {
//     apiKey: "AIzaSyCp5mB5i5NyTi0zZ1Xs7x7sWLy3kR0xz8w",
//     authDomain: "mtb-trail-status-dev.firebaseapp.com",
//     databaseURL: "https://mtb-trail-status-dev.firebaseio.com",
//     projectId: "mtb-trail-status-dev",
//     storageBucket: "mtb-trail-status-dev.appspot.com",
//     messagingSenderId: "24924440040",
//     appId: "1:24924440040:web:0e90664e28a551f426905d"
// };

firebase.initializeApp(config);

export default firebase;